/**
 * Buy X Get Y Configuration
 * 
 * This file provides helper functions for managing Buy X Get Y offers.
 * The actual configuration is now generated dynamically from theme settings
 * via the buy-x-get-y-settings.liquid snippet.
 * 
 * Configuration is available at: window.buyXGetYConfig
 */


// Helper function to add new offers programmatically
window.addBuyXGetYOffer = function(offer) {
  if (!window.buyXGetYConfig.offers) {
    window.buyXGetYConfig.offers = [];
  }
  window.buyXGetYConfig.offers.push(offer);
};

// Helper function to remove offers
window.removeBuyXGetYOffer = function(offerId) {
  if (window.buyXGetYConfig.offers) {
    window.buyXGetYConfig.offers = window.buyXGetYConfig.offers.filter(
      offer => offer.id !== offerId
    );
  }
};

// Helper function to enable/disable offers
window.toggleBuyXGetYOffer = function(offerId, enabled) {
  if (window.buyXGetYConfig.offers) {
    const offer = window.buyXGetYConfig.offers.find(o => o.id === offerId);
    if (offer) {
      offer.enabled = enabled;
    }
  }
};

// Debug functions
window.debugBuyXGetY = function() {
  console.log('Buy X Get Y Config:', window.buyXGetYConfig);
  console.log('Auto Add Instance:', window.BuyXGetYAutoAdd);
  
  // Test cart fetch
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log('Current Cart:', cart);
      console.log('Cart Items:', cart.items);
    })
    .catch(error => console.error('Cart fetch error:', error));
};

// Force process offers
window.forceProcessOffers = function() {
  if (window.BuyXGetYAutoAdd && window.BuyXGetYAutoAdd.instance) {
    window.BuyXGetYAutoAdd.instance.handleCartUpdate();
  } else {
    console.log('Auto Add instance not found');
  }
};

// Fix the configuration value issue
window.fixBuyXGetYConfig = function() {
  if (window.buyXGetYConfig && window.buyXGetYConfig.offers) {
    window.buyXGetYConfig.offers.forEach(offer => {
      if (offer.name === 'Buy 2 Get 1 Free' && offer.condition.value === 1) {
        offer.condition.value = 2;
        console.log('Fixed offer value from 1 to 2 for:', offer.name);
      }
    });
    console.log('Updated config:', window.buyXGetYConfig);
  }
};

// Helper function to find product by handle and get its ID and variant ID
window.findProductInfo = async function(productHandle) {
  try {
    const response = await fetch(`/products/${productHandle}.js`);
    if (response.ok) {
      const product = await response.json();
      console.log('Product found:', {
        id: product.id,
        title: product.title,
        handle: product.handle,
        variants: product.variants.map(v => ({
          id: v.id,
          title: v.title,
          available: v.available,
          price: v.price
        }))
      });
      return product;
    } else {
      console.error('Product not found:', productHandle, response.status);
    }
  } catch (error) {
    console.error('Error fetching product:', error);
  }
};

// Helper function to find variant by ID and get its details
window.findVariantInfo = async function(variantId) {
  try {
    const response = await fetch(`/variants/${variantId}.js`);
    if (response.ok) {
      const variant = await response.json();
      console.log('Variant found:', {
        id: variant.id,
        title: variant.title,
        product_id: variant.product_id,
        available: variant.available,
        price: variant.price,
        sku: variant.sku
      });
      return variant;
    } else {
      console.error('Variant not found:', variantId, response.status);
    }
  } catch (error) {
    console.error('Error fetching variant:', error);
  }
};

// Helper function to test if a product handle exists
window.testProductHandle = async function(productHandle) {
  try {
    const response = await fetch(`/products/${productHandle}.js`);
    if (response.ok) {
      const product = await response.json();
      console.log('Product handle is valid:', {
        id: product.id,
        title: product.title,
        handle: product.handle,
        available: product.available
      });
      return true;
    } else {
      console.error('Product handle is invalid:', productHandle, response.status);
      return false;
    }
  } catch (error) {
    console.error('Error testing product handle:', error);
    return false;
  }
};

// Example usage in console:
// debugBuyXGetY() - Check current configuration and cart
// forceProcessOffers() - Manually trigger offer processing
// fixBuyXGetYConfig() - Fix the value from 1 to 2 for Buy 2 Get 1 offers
// testProductHandle('product-handle') - Test if a product handle exists
// findProductInfo('product-handle') - Find product info by handle
// findVariantInfo(1234567890) - Find variant info by ID
// addBuyXGetYOffer({
//   id: 'new-offer',
//   name: 'New Offer',
//   enabled: true,
//   condition: {
//     type: 'quantity',
//     value: 3,
//     products: ['1234567890']
//   },
//   rewards: [
//     { product_handle: 'cable', variant_id: 8888888888, quantity: 1 }, // Blue Cable
//     { product_handle: 'cable', variant_id: 7777777777, quantity: 1 }  // Green Cable
//   ]
// });